"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SksgV2FirmwareUpdateCommandSerialization = void 0;
class SksgV2FirmwareUpdateCommandSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.SksgV2FirmwareUpdateCommandSerialization = SksgV2FirmwareUpdateCommandSerialization;
